import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { class: "d-flex search-buttons" }

import i18n from '@/lang/i18n'
import { Ref, reactive, ref, computed, onMounted } from 'vue'
import {
  saveDataToSessionStorage,
  loadDataFromSessionStorage,
  clearSessionStorage
} from '@/services/functions/sessionStorage'
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue'
import getOperationOffice from '@/types/responses/getOperationOffice'

const SESSION_STORAGE_NAME = 'gpsTrackerSettingSearchForm'

type SearchForm = {
  operationOffice: getOperationOffice | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ["search", "formchange"],
  setup(__props: any, { emit: __emit }) {

const hide: Ref<boolean> = ref(false)
const form = reactive<SearchForm>({
  operationOffice: null,
})

const emits = __emit
const props = __props

onMounted(()=> {
  const savedFormValues = loadDataFromSessionStorage(SESSION_STORAGE_NAME) as SearchForm | null
  if (savedFormValues) {
    form.operationOffice = savedFormValues.operationOffice;
  }
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})
const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})
const changeSearchButton = computed(() => {
  return props.isLoading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})
function toggleSidebar () {
  hide.value = !hide.value
}

function handleClickSearch() {
  emits('search', form)
  saveDataToSessionStorage(SESSION_STORAGE_NAME, form)
}
function clearForm () {
  form.operationOffice = null
  clearSessionStorage(SESSION_STORAGE_NAME);
}


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SingleOperationOfficeAutoComplete, {
          modelValue: form.operationOffice,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.operationOffice) = $event)),
          clearable: true,
          selectFirstIfOnlyOne: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_v_divider, {
        thickness: 3,
        class: "my-2"
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          class: "ma-2 exec-btn",
          onClick: handleClickSearch,
          disabled: props.isLoading,
          style: _normalizeStyle({
            backgroundColor : props.isLoading ? '#B3B8BB' : ''
          })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
          ]),
          _: 1
        }, 8, ["disabled", "style"]),
        _createVNode(_component_v_btn, {
          class: "ma-2 reset-btn",
          disabled: props.isLoading,
          onClick: clearForm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2)
  ], 2))
}
}

})